"use strict";
/**
 * dom.js provides a way to build a DOM tree easily.
 *
 * E.g.
 *  import {dom} from 'grainjs';
 *  dom('a#link.c1.c2', {'href': url}, 'Hello ', dom('span', 'world'));
 *    creates Node <a id="link" class="c1 c2" href={{url}}Hello <span>world</span></a>.
 *
 *  dom.frag(dom('span', 'Hello'), ['blah', dom('div', 'world')])
 *    creates document fragment with <span>Hello</span>blah<div>world</div>.
 *
 * DOM can also be created and modified inline during creation:
 *  dom('a#id.c1',
 *      dom.cls('c2'), dom.attr('href', url),
 *      dom.text('Hello '), dom('span', dom.text('world')))
 *    creates Node <a id="link" class="c1 c2" href={{url}}Hello <span>world</span></a>,
 *    identical to the first example above.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dom = void 0;
// We keep various dom-related functions organized in private modules, but they are exposed here.
__exportStar(require("./domImpl"), exports);
__exportStar(require("./domComponent"), exports);
__exportStar(require("./domComputed"), exports);
__exportStar(require("./domDispose"), exports);
__exportStar(require("./domForEach"), exports);
__exportStar(require("./domMethods"), exports);
__exportStar(require("./domevent"), exports);
const _domComponent = require("./domComponent");
const _domComputed = require("./domComputed");
const _domDispose = require("./domDispose");
const _domForEach = require("./domForEach");
const _domImpl = require("./domImpl");
const _domMethods = require("./domMethods");
const domevent = require("./domevent");
const domImpl_1 = require("./domImpl");
// We just want to re-export _domImpl.dom, but to allow adding methods to it in a typesafe way,
// TypeScript wants us to declare a real function in the same file.
function dom(tagString, ...args) {
    return domImpl_1.dom(tagString, ...args);
}
exports.dom = dom;
// Additionally export all methods as properties of dom() function.
(function (dom) {
    dom.svg = _domImpl.svg;
    dom.frag = _domImpl.frag;
    dom.update = _domImpl.update;
    dom.find = _domImpl.find;
    dom.findAll = _domImpl.findAll;
    dom.domDispose = _domDispose.domDispose;
    dom.onDisposeElem = _domDispose.onDisposeElem;
    dom.onDispose = _domDispose.onDispose;
    dom.autoDisposeElem = _domDispose.autoDisposeElem;
    dom.autoDispose = _domDispose.autoDispose;
    dom.attrsElem = _domMethods.attrsElem;
    dom.attrs = _domMethods.attrs;
    dom.attrElem = _domMethods.attrElem;
    dom.attr = _domMethods.attr;
    dom.boolAttrElem = _domMethods.boolAttrElem;
    dom.boolAttr = _domMethods.boolAttr;
    dom.textElem = _domMethods.textElem;
    dom.text = _domMethods.text;
    dom.styleElem = _domMethods.styleElem;
    dom.style = _domMethods.style;
    dom.propElem = _domMethods.propElem;
    dom.prop = _domMethods.prop;
    dom.showElem = _domMethods.showElem;
    dom.show = _domMethods.show;
    dom.hideElem = _domMethods.hideElem;
    dom.hide = _domMethods.hide;
    dom.clsElem = _domMethods.clsElem;
    dom.cls = _domMethods.cls;
    dom.clsPrefix = _domMethods.clsPrefix;
    dom.dataElem = _domMethods.dataElem;
    dom.data = _domMethods.data;
    dom.getData = _domMethods.getData;
    dom.replaceContent = _domComputed.replaceContent;
    dom.domComputed = _domComputed.domComputed;
    dom.domComputedOwned = _domComputed.domComputedOwned;
    dom.maybe = _domComputed.maybe;
    dom.maybeOwned = _domComputed.maybeOwned;
    dom.forEach = _domForEach.forEach;
    dom.create = _domComponent.create;
    dom.onElem = domevent.onElem;
    dom.on = domevent.on;
    dom.onMatchElem = domevent.onMatchElem;
    dom.onMatch = domevent.onMatch;
    dom.onKeyElem = domevent.onKeyElem;
    dom.onKeyPress = domevent.onKeyPress;
    dom.onKeyDown = domevent.onKeyDown;
})(dom = exports.dom || (exports.dom = {}));
//# sourceMappingURL=dom.js.map